import React from 'react';
import { Input } from '../../../components/ui/input';

const SearchBox = ({ value, onChange }) => {
  return (
    <div>
      <Input
        type="text"
        placeholder="Search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-9 bg-white"
      />
    </div>
  );
};

export default SearchBox;